import React from 'react';
import EventPreview from './EventPreview';
import TournamentFetcher from './TournamentFetcher';
import TournamentHeader from './TournamentHeader';
import EventContainer from './event/EventContainer';
import { usePrematchData } from './PrematchDataFetcher';
import { useParams } from '../router/Router';
import ContentWrapper from '../common/ContentWrapper';
import { iconCategoryCssClass, iconSportCssClass } from '../data/utils';
import SportHeader from '../common/SportHeader';
import InfoMessage from '../common/InfoMessage';
import { getLabel } from '../InitData';
import ErrorMessage from '../common/ErrorMessage';
import FavoriteEvents from './favorite-events/FavoriteEvents';
import WidgetContainer from '../common/WidgetContainer';

export default function TournamentsList() {
    const prematchData = usePrematchData();
    const p = useParams();

    try {
        const sport = prematchData.sportById[p.sportId];
        const sportIcon = iconSportCssClass(sport.id, sport.iconClass);
        const category = sport.categoryById[p.categoryId];
        const categoryIcon = iconCategoryCssClass(category.sportRef, category.categoryRef, category.categoryIcon);
        const t = category.tournamentById[p.tournamentId];
        const [pal, avv] = [p.pal, p.avv];
    
        return (
            <ContentWrapper columns="2">
                <TournamentFetcher data={t} renderItem={(tournamentData) => {
                    let event = tournamentData.events.find(e => e.pal === pal && e.avv === avv);
                    if (event == null) {
                        event = tournamentData.outrights.find(e => e.pal === pal && e.avv === avv);
                        if (event == null) {
                            return <InfoMessage text={getLabel('general.no_events')} />
                        }
                    }
                    
                    return (
                        <>
                            <div className="c_30">
                                <WidgetContainer data-sticky />
                                <div className="c_30_1">
                                    <FavoriteEvents preview={true} />
                                    <SportHeader icon={sportIcon} desc={sport.descrizione} />
                                    <TournamentHeader icon={categoryIcon} desc={tournamentData.descrizione} />
                                    {tournamentData.events.map(e =>
                                        <EventPreview key={e.uniqueId} data={e} active={e.uniqueId === event.uniqueId} />
                                    )}
                                </div>
                            </div>
                            <EventContainer data={event} />
                        </>
                    );
                }}
                />
            </ContentWrapper>
        );
    } catch (e) {
        return <ErrorMessage text={getLabel('general.error')} />
    }
}
